<template>

<div>

  <app-header />


  <div class="container">

		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item"><router-link :to="'/project/'+project.id">{{ project.name }}</router-link></li>
				<li class="breadcrumb-item active" aria-current="page">{{ _lang('Collections') }}</li>
			</ol>
		</nav>

      <table class="table">
        <tbody>
          <tr v-for="table in project.tables">
            <td>{{ table.name }}</td>
            <td class="text-right"><router-link class="btn btn-light" :to="'/project/'+project.id+'/table/'+table.id">{{ _lang('Edit collection') }}</router-link></td>
            <td class="text-right"><router-link class="btn btn-light" :to="'/project/'+project.id+'/table/'+table.id+'/fields'">{{ _lang('Manage fields') }}</router-link></td>
            <td class="text-right"><router-link class="btn btn-primary" :to="'/project/'+project.id+'/table/'+table.id+'/browse'">{{ _lang('Manage data') }}</router-link></td>
          </tr>
        </tbody>
      </table>
      <router-link :to="'/project/'+project.id+'/table/new'" class="btn btn-primary">{{ _lang('New collection') }}</router-link>

    </div>
</div>

</template>
<script>

import axios from 'axios';
import appHeader from '../components/appHeader.vue'

export default {
  name: 'project',
  props:['project_id'],
  components:{
    appHeader,
  },
  data() {
    return {

    }
	},
	computed:{
		project(){
			return this.$store.state.project
		},

	},
  methods:{
    url(slug,page){
      var url = process.env.VUE_APP_PROTOCOL+'://'+slug+'.'+process.env.VUE_APP_BASEURL;
      if(page) url += '/'+page.replace(/\/$/,'')
      return url;
    },
    dataBr(data){
      var d = new Date(data);
      return ('0'+d.getDate()).substr(-2) + '/' +('0'+(d.getMonth()+1)).substr(-2)+'/'+d.getFullYear();
    },



    newTable(){


    },

  },
  mounted(){
		if(!this.project.id){
			this.$store.dispatch('getProject',this.project_id)
		}
  }

}



</script>

<style>

</style>
